module.exports = __webpack_public_path__ + "img/quanqiuv2.007fb2c2.svg";